import faunadb from "faunadb";

/* configure faunaDB Client with our secret */
export const q = faunadb.query;
// client needs to be mutable so it can dynamically re-initialise when a new user logs in.
// eslint-disable-next-line import/no-mutable-exports
export let client = new faunadb.Client({
  secret: process.env.VUE_APP_FAUNADB_SERVER_SECRET
});

